import React from 'react';
import SiteFooter from '../Footer/SiteFooter';

function Footer() {
    return <SiteFooter variant="marketing" />;
}

export default Footer;